import { ActorProfilePreviewFragmentFragment } from '@lopo-tech/lopo-api'
import React from 'react'
import Avatar from 'src/components/avatar/avatar'
import NavigationItem from 'src/components/navigation_item/navigation_item'
import { getDateTimeFormat } from 'src/components/post/utils'
import {
  THUMBNAIL_SIZE_TYPE_SMALL,
  ThumbnailSizeType
} from 'src/components/thumbnail/thumbnail'
import { CLASS_PREFIX } from 'src/constants/'
import { PostDisplayMode } from 'src/interfaces/posts'
import { getSponsorBadge } from 'src/utils/badges'
import { UrlUtils } from 'src/utils/url/url'
import UserOnboardingCTA from '../../../../containers/smart_components/user_onboarding_cta/user_onboarding_cta'
import './author.scss'

export interface IProps {
  author: ActorProfilePreviewFragmentFragment;
  publishedAt?: string | null;
  displayMode: PostDisplayMode;
  size?: ThumbnailSizeType;
}

export const cls = `${CLASS_PREFIX}author__`

const Author: React.FC<IProps> = ({ author, publishedAt, displayMode, size }) => {
  const authorClass = `${cls}${displayMode}`
  const isDisabled = !author.canShow.value

  if (!author) {
    return null
  }

  const { __typename, avatar: { previewUrl: imageUrl }, name, shapeSponsorshipLevel, slug } = author

  const profileLink = UrlUtils.getProfileFrontendPath(slug, __typename)

  const avatarSize = size || THUMBNAIL_SIZE_TYPE_SMALL

  return (
    <UserOnboardingCTA active={isDisabled}>
      <div className={authorClass}>
        <div className={authorClass + '__avatar-container'}>
          <NavigationItem target="_self" url={profileLink}>
            <Avatar
              image={imageUrl}
              size={avatarSize}
              badge={
                shapeSponsorshipLevel && getSponsorBadge(shapeSponsorshipLevel)
              }
              rounded={false}
            />
          </NavigationItem>
        </div>
        <div className={authorClass + '__description'}>
          <NavigationItem
            target="_self"
            url={profileLink}
            className={`${authorClass}__name ${authorClass}__name-${__typename}`}
          >
            <span>{name}</span>
          </NavigationItem>
          <div className={authorClass + '__where-and-when'}>
            {publishedAt && (
              <time dateTime={publishedAt}>
                {getDateTimeFormat(publishedAt)}
              </time>
            )}
          </div>
        </div>
      </div>
    </UserOnboardingCTA>
  )
}

export default Author
